<template>
  <div class="video-player">
    <video
            ref="articleVideo"
            webkit-playsinline="true"
            playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x-webkit-airplay="allow"
            x5-video-orientation="portraint"
            :poster="cover"
            :src="video"
            @playing="playing"
            @ended="ended"
            @click="pause"
    ></video>
    <span class="video-play" v-if="!is_play" @click="videoPlay">
      <img src="../assets/icons/video_play.svg" alt="" />
    </span>
  </div>
</template>
<script>
export default {
  name: "video-player",
  components: {},
  props:{
    video:{
      type:String
    },
    cover:{
      type:String
    }
  },
  data() {
    return {
      is_play:false
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    videoPlay() {
      this.$refs.articleVideo.play();
    },
    playing() {
      this.is_play = true;
    },
    ended() {
      this.is_play = false;
    },
    pause() {
      if (this.$refs.articleVideo.end) {
        this.$refs.articleVideo.play();
        return true;
      }
      if (this.$refs.articleVideo.paused) {
        this.$refs.articleVideo.play();
        return true;
      }
      this.is_play = false;
      this.$refs.articleVideo.pause();
    },
  },
  watch: {}
};
</script>
<style lang="scss">
  .video-player{
    width: 100%;
    height: 100%;
    video {
      width: 100%;
      height: 100%;
    }
    .video-play {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      left: 0;
      img {
        width: 0.8rem;
        height: 0.8rem;
      }
    }
  }
</style>
